export const endEvent = 'bpmn:EndEvent';
export const startEvent = 'bpmn:StartEvent';
export const connection = 'bpmn:SequenceFlow';
export const subProcess = 'SubProcess';
export const subProcessType = `bpmn:${subProcess}`;
export const association = 'Association';
export const textAnnotation = 'TextAnnotation';
export const exclusiveGateway = 'ExclusiveGateway';
export const exclusiveGatewayType = `bpmn:${exclusiveGateway}`;
export const task = 'Task';
export const taskType = `bpmn:${task}`;
export const userTaskType = 'bpmn:UserTask';
export const scriptTaskType = 'bpmn:ScriptTask';
export const processType = 'bpmn:Process';
export const incoming = 'bpmn:incoming';
export const outgoing = 'bpmn:outgoing';
export const connectionExpression = 'bpmn:FormalExpression';
export const extensionElements = 'bpmn:ExtensionElements';
export const nodesDetailsExtensionType = 'pw:NodeDetails';
export const trackingChangeExtensionType = 'pw:TrackingChange';
export const guideBoxPropertyExtensionType = 'pw:GuideBox';
export const nodeDetailsField = 'pw:Field';
export const nodeDetailsQuestion = 'pw:Question';
export const HEAD_NODE_ID = 'head_node_id';
export const END_NODE_ID = 'end_node_id';
export const ClipboardName = 'clipboard';
export const AUTOMATION_ID = 'automationID';
export const ELEMENT_ID = 'data-element-id';
